import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { UserIcon2 } from '../components/shared/Icons';
import {
  CasualsAvailabilityProvider,
  CasualsCreate,
  CasualsMine,
  CasualsJobs,
  CasualsCompleted,
  CasualsMessages,
} from './CasualsAvailability';
import { AvailableDaysBadge, PendingJobsBadge, DoneJobsBadge, CasualMessagesBellBadge } from './casualTabBadges';

// InnerTabsm takes at most 3 tabs, so the five casual views split across two
// outer tabs. One provider wraps both so state is shared between them.
const TABS = [
  { id: 'availabilitym', label: 'Availability' },
  { id: 'jobsm',         label: 'Jobs' },
];

const AVAILABILITY_INNER = [
  { id: 'casualsavailablem', label: 'Create Availability', icon: <UserIcon2 />, component: CasualsCreate },
  { id: 'myavailablem',      label: 'My Availability',   icon: <UserIcon2 />, component: CasualsMine, placeholder: AvailableDaysBadge },
];
const JOBS_INNER = [
  { id: 'assignedjobsm',  label: 'Assigned Jobs',     icon: <UserIcon2 />, component: CasualsJobs,      placeholder: PendingJobsBadge },
  { id: 'jobscompletedm', label: 'Jobs Completed',     icon: <UserIcon2 />, component: CasualsCompleted, placeholder: DoneJobsBadge },
  { id: 'messagesm',      label: 'Messages', icon: <UserIcon2 />, component: CasualsMessages,  placeholder: CasualMessagesBellBadge },
];

const FilterAvailablestaffm = () => {
  const [activeTab, setActiveTab] = useState('availabilitym');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} homeRoute="/profile" homeColor={homeAccent} />
      <div className="fr-tab-content">
        <CasualsAvailabilityProvider>
          {activeTab === 'availabilitym' && <InnerTabsm tabs={AVAILABILITY_INNER} defaultId="casualsavailablem" />}
          {activeTab === 'jobsm' && <InnerTabsm tabs={JOBS_INNER} defaultId="assignedjobsm" />}
        </CasualsAvailabilityProvider>
      </div>
    </div>
  );
};

export default FilterAvailablestaffm;